module.exports = __webpack_public_path__ + "img/panoramic-prices.4c3b66eb.jpg";